<template>
  <div class="pix-blurred-field blurred" v-text="genericFunctionsUtils.getRandomFieldValue()" />
</template>

<script>
import genericFunctionsUtils from '@/services/common/genericFunctions.utils';

export default {
  data() {
    return {
      genericFunctionsUtils,
    };
  },
};
</script>

<style scoped>
.pix-blurred-field {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
